import { render, staticRenderFns } from "./AnswerRacerStudent.vue?vue&type=template&id=04109e59"
import script from "./AnswerRacerStudent.vue?vue&type=script&lang=js"
export * from "./AnswerRacerStudent.vue?vue&type=script&lang=js"
import style0 from "./AnswerRacerStudent.vue?vue&type=style&index=0&id=04109e59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports